import { FormValidators } from '@servicetitan/form-state';

const maxLength = 250;

export const DEFAULT_CONFIGURATION_VALIDATORS = [FormValidators.maxLength(maxLength)];

export const REQUIRED_CONFIGURATION_VALIDATORS = [
    ...DEFAULT_CONFIGURATION_VALIDATORS,
    FormValidators.required,
];

/*
 * Email Sender Domain must be a bare domain: exactly two labels (e.g. abcde.com) —
 * no protocol, no path, no subdomain.
 */
const SENDER_DOMAIN_REGEX = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?\.[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i;

export const isValidSenderDomain = (value: string): boolean =>
    SENDER_DOMAIN_REGEX.test(value.trim());

export const SENDER_DOMAIN_VALIDATORS = [
    FormValidators.required,
    FormValidators.maxLength(maxLength),
    FormValidators.isMatchingRegex(SENDER_DOMAIN_REGEX, 'domain'),
];
